import moment from "moment";

import type { HighYieldCashAccruedInterestSummary } from "~/v2/api/rest/hyc";

export const getIsEligibleForHighYieldCash = ({
  product,
  currency,
  accountStatus,
}: {
  product: string | undefined;
  currency: string | undefined;
  accountStatus: string | undefined;
}) =>
  product === "live" &&
  currency === "USD" &&
  (accountStatus === "ACTIVE" || accountStatus === "APPROVED");

/**
 * @param date - date to get the monthly accrued interest rate for.
 */
export const getMonthlyAccruedInterest = ({
  hycAccruedInterest,
  date = moment(),
}: {
  hycAccruedInterest: HighYieldCashAccruedInterestSummary[];
  date?: moment.Moment;
}) =>
  hycAccruedInterest
    .filter((interest) => {
      const interestDate = moment(interest.date);
      return interestDate.isSame(date, "day");
    })
    .reduce((accumulator, current) => {
      const interest = Number(current.monthly_accrued_interest);
      return interest + accumulator;
    }, 0);

export const getTotalAccruedInterest = ({
  hycAccruedInterest,
  date = moment(),
}: {
  hycAccruedInterest: HighYieldCashAccruedInterestSummary[];
  date?: moment.Moment;
}) =>
  hycAccruedInterest
    .filter((interest) => {
      const interestDate = moment(interest.date);
      return interestDate.isSame(date, "day");
    })
    .reduce((accumulator, current) => {
      const interest = Number(current.total_accrued_interest);
      return interest + accumulator;
    }, 0);

export const getAccruedInterestBalance = ({
  hycAccruedInterest,
  date = moment(),
}: {
  hycAccruedInterest: HighYieldCashAccruedInterestSummary[];
  date?: moment.Moment;
}) =>
  hycAccruedInterest
    .filter((interest) => {
      const interestDate = moment(interest.date);
      return interestDate.isSame(date, "day");
    })
    .reduce((accumulator, current) => {
      const balance = Number(current.balance);
      return balance + accumulator;
    }, 0);

export const HIGH_YIELD_APPLIED_KEY = "hyc_applied";

export const getHighYieldCashLocalStorageKey = (accountId?: string) =>
  `${HIGH_YIELD_APPLIED_KEY}-${accountId ?? ""}`;
